import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import { createBrowserHistory } from 'history';
import app from './firebase';

import SinglePost from "./components/single-post/SinglePost";

import './App.css';
import './style/main.scss';

import Navbar from './components/Navbar';

import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import ResourcePage from './pages/ResourcePage';
import Posts from './components/posts/Posts';

class App extends React.Component {
  render(){
    const rainge = require('rainge');
    app.analytics()
    return (
      <Router history={createBrowserHistory()}>
        <ScrollToTop />        
        <Navbar />
        
        <Switch>
          <Route exact path='/'>
            <HomePage />
            <div className='container'>
              <Posts />
            </div>
          </Route>
          <Route path='/contact'>
            <ContactPage />
          </Route>
          <Route path='/resource'>
            <ResourcePage />
          </Route>
          <Route path="/:id">
            <div className='container'>
              <SinglePost />
            </div>
          </Route>
        </Switch>          
        

        <div id='footer'><small>Website created by <a href='https://muhfasul.com' rel="noopener noreferrer" target='_blank'>Muhfasul Alam</a><br/>All Materials © {rainge(2014)}, Jon Mannion</small></div>
      </Router>
    );
  }
}

export default App;
